"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var forms_1 = require("@/util/forms");
var strings_1 = require("@/util/strings");
/**
 * This implements MessageHandler interface
 * @param message
 * @param value
 */
function default_1(message, value) {
    value.event = 'GAeventForm';
    value.eventContent = 'Form';
    return message.name === 'FormError' ? generateFormErrorEvent(message, value) : generateInteractionFormEvent(message, value);
}
exports.default = default_1;
;
var eventNameBlacklist = {
    ntbRequest: true,
    smsRequest: true,
    smsCodeRequest: true,
    restore: true
};
function allowMessageValue(message) {
    if (message.category === 'field') {
        return false;
    }
    if (message.name && (message.name in eventNameBlacklist)) {
        return false;
    }
    return true;
}
var generateInteractionFormEvent = function (message, value) {
    value.eventType = value.eventLabel = message.name || '';
    value.eventCategory = 'interaction form';
    value.eventFormVendor = message.vendor || '';
    value.eventStepType = (message.pageFinal ? 'final' : '') + (0, strings_1.upperFirst)(message.pageRole || '');
    value.eventElementType = (0, forms_1.mapElementName)(message.event);
    value.eventFieldNumber = (message.fieldNumber || '').toString();
    if (message.event && message.event.target) {
        value.eventLabel += ' ' + message.event.target.tagName;
    }
    if (message.context) {
        value.eventContext = message.context;
    }
    if (message.datapath) {
        var elementName = message.subpath && message.subpath.length > 0
            ? message.datapath + ':' + message.subpath.reverse().join('.')
            : message.datapath;
        if (!message.context) {
            value.eventContext = elementName;
        }
        value.eventElementName = elementName;
    }
    if (message.page) {
        value.eventStep = value.eventAction = message.page.toString();
    }
    if (message.form) {
        value = __assign(__assign({}, value), generateFormMetas(message.form));
    }
    if (allowMessageValue(message)) {
        value.eventValue = ('' + message.value) || '';
    }
    return value;
};
var generateFormErrorEvent = function (message, value) {
    value.eventCategory = 'Form Error';
    value.eventAction = 'Load Error';
    value.eventLabel = message.label || '';
    value.eventType = message.name || '';
    value.eventFormVendor = message.vendor || '';
    if (message.context) {
        value.eventContext = message.context;
    }
    if (message.form) {
        value = __assign(__assign({}, value), generateFormMetas(message.form));
    }
    return value;
};
var generateFormMetas = function (form) { return ({
    eventFormDesign: form.view || '',
    eventFormName: form.name || '',
    eventFormVersion: form.version || ''
}); };
